import React from 'react';
import { PillIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
type ExperienceKey = 'innova' | 'rx';
interface ExperienceOption {
  id: ExperienceKey;
  label: string;
  description: string;
  icon: React.ReactNode;
  iconClass: string;
  animation: {
    scale?: number[];
    y?: number[];
    rotate?: number[];
  };
}
const experiences: ExperienceOption[] = [{
  id: 'innova',
  label: 'NOW',
  description: '120 min delivery',
  icon: <ZapIcon strokeWidth={2.1} data-id="element-2371" data-mp="8twxwd25yn4o" />,
  iconClass: 'bg-[#e5f5f4] text-[#18706d]',
  animation: {
    scale: [1, 1.1, 1]
  }
}, {
  id: 'rx',
  label: 'RX',
  description: 'Health services',
  icon: <PillIcon strokeWidth={2} data-id="element-2372" data-mp="humpt5oaztd4" />,
  iconClass: 'bg-[#f0eaff] text-[#6a4eb5]',
  animation: {
    rotate: [0, -7, 0]
  }
}];
interface MobileExperienceSwitcherProps {
  activeExperience?: ExperienceKey;
  isCompact?: boolean;
  onSelect?: (experience: ExperienceKey) => void;
}
export function MobileExperienceSwitcher({
  activeExperience = 'innova',
  onSelect
}: MobileExperienceSwitcherProps) {
  const shouldReduceMotion = useReducedMotion();
  return <nav aria-label="Shopping experience" className="mt-1 bg-transparent px-4 pb-1.5 pt-1" data-id="element-2373" data-mp="3c6ix1vpcpl1h">
      <div className="grid h-[54px] w-full grid-cols-2 rounded-xl border border-[#dce3ec] bg-[#f4f7fb] p-1" data-id="element-2374" data-mp="375ldbeop0ixv">
        {experiences.map(experience => {
        const isActive = experience.id === activeExperience;
        return <button key={experience.id} type="button" aria-current={isActive ? 'page' : undefined} aria-label={`${experience.label} experience`} onClick={() => onSelect?.(experience.id)} className={`relative flex min-w-0 items-center gap-2 rounded-lg px-2 text-left transition-[background-color,border-color] duration-150 focus:outline-none focus:ring-2 focus:ring-[#103d91] focus:ring-inset ${isActive ? 'border border-[#e4e9f0] bg-white' : 'border border-transparent bg-transparent'}`} data-id="element-2375" data-mp="2y81f6em4n2rh">
              <motion.span animate={shouldReduceMotion ? {
            scale: 1,
            y: 0,
            rotate: 0
          } : experience.animation} transition={{
            duration: 0.75,
            repeat: shouldReduceMotion ? 0 : Infinity,
            repeatDelay: 3.2,
            ease: [0.22, 1, 0.36, 1]
          }} className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md ${experience.iconClass}`} aria-hidden="true" data-id="element-2376" data-mp="24udc5g5wcr8d">
                <span className="[&>svg]:h-3.5 [&>svg]:w-3.5" data-id="element-2377" data-mp="2ohaxtimm1bd2">{experience.icon}</span>
              </motion.span>
              <span className="min-w-0 leading-none" data-id="element-2378" data-mp="29t6m4ylz603s">
                <span className={`block truncate text-xs font-bold ${isActive ? 'text-[#1E2B55]' : 'text-[#61708a]'}`} data-id="element-2379" data-mp="2es9htsg2etz3">{experience.label}</span>
                <span className="mt-1 block truncate text-[9px] font-medium text-[#7a879b]" data-id="element-2380" data-mp="32gstmhybpovx">{experience.description}</span>
              </span>
              {isActive && <span className="absolute bottom-0 left-3 right-3 h-0.5 rounded-full bg-[#2d6fcd]" aria-hidden="true" data-id="element-2381" data-mp="vtlbgvfco3ex" />}
            </button>;
      })}
      </div>
    </nav>;
}